<template>
  <div class="attendance-tab-container">
    <el-tabs
        tab-position="top"
        type="card"
        v-model="localTab"
        @tab-click="onTabClick"
        class="custom-attendance-tabs"
    >
      <el-tab-pane label="Lớp" name="class" />
      <el-tab-pane label="Nhóm" name="group" />
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'AttendanceTabSwitcher',
  props: {
    value: { type: String, default: 'class' }
  },
  computed: {
    localTab: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    }
  },
  methods: {
    onTabClick(tab) {
      this.$emit('change', tab.name)
    }
  }
}
</script>

<style scoped lang="scss">
.attendance-tab-container {
  display: flex;
  justify-content: flex-end; /* Đẩy tab về bên phải giống như logic cũ của anh */
}

.custom-attendance-tabs {
  width: auto;
  margin-right: 8px;

  // ─── CẤU TRÚC KHUNG THANH TABS ───────────────────────────────────
  /deep/ .el-tabs__header {
    margin: 0 !important;
    border-bottom: none !important;
  }

  /deep/ .el-tabs__nav {
    border-radius: 8px 8px 0 0 !important;
    overflow: hidden;
    background-color: #f1f5f9 !important; /* Nền xám nhạt hiện đại thay cho màu tối cũ */
    display: flex;
    gap: 4px;
  }

  /deep/ .el-tabs__nav-wrap {
    border-bottom: none !important;
  }

  // ─── STYLE CÁC THẺ PHẦN TỬ (TAB ITEMS) ────────────────────────────
  /deep/ .el-tabs__item {
    border: none !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 34px !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    color: #64748b !important; /* Chữ xám đậm tinh tế khi chưa kích hoạt */
    background-color: transparent !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      color: #78a5e7 !important;
    }

    // Trạng thái Tab đang được chọn (Active)
    &.is-active {
      background-color: #6a96d6 !important; /* Giữ màu xanh dương thương hiệu của anh */
      color: #ffffff !important; /* Chữ trắng nổi bật */
      box-shadow: 0 2px 8px rgba(120, 165, 231, 0.4); /* Đổ bóng nhẹ tạo độ nổi khối */
    }
  }
}
</style>